<template>
    <div class="close-issue-wrap">
        <span>关闭issue</span>
        <span class="end-conversation">结束本轮对话</span>
    </div>
</template>

<script>
export default {
    name: "IssueAction",
    mounted() {
        this.$emit("change", { close: true });
    },
    methods: {
        validate() {
            return true;
        }
    }
};
</script>

<style lang="less" scoped>
@contentWidth: 730px;

.close-issue-wrap {
    margin-top: 13px;
    width: @contentWidth;
    height: 49px;
    background: #fbfcfd;
    border: 1px solid #d8e4f0;
    padding: 14px 16px;
    font-size: 14px;
    box-sizing: border-box;

    .end-conversation {
        font-size: 12px;
        color: #999999;
        margin-left: 18px;
    }
}
</style>
